// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"imgContainer__1MKGh","spin":"spin__1Vpo9","buttonLoader":"buttonLoader__2mMFV","loadingContainer":"loadingContainer__3EtTS","centerLoader":"centerLoader__3uT74"};